import { render, staticRenderFns } from "./SlideArtist.vue?vue&type=template&id=015da86c&"
import script from "./SlideArtist.vue?vue&type=script&lang=js&"
export * from "./SlideArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports